var map = {
	"./great-wall-family-history/metadata.json": 6863,
	"./life-changing-china-experience/metadata.json": 7850,
	"./modern-china-traditional-culture/metadata.json": 4609,
	"./tea-culture-bridge/metadata.json": 6128,
	"./teaching-english-rural-china/metadata.json": 8616,
	"./vr-poetry-experience/metadata.json": 3120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6026;